import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Endbar.css'; // Importa o arquivo CSS atualizado
import logo from '../assets/logoNome.png';

function Endbar() {
  const navigate = useNavigate();  // Usando useNavigate para navegação programática

  const handleScrollToTop = () => {
    navigate('/');  // Redireciona para a home
    window.scrollTo(0, 0);  // Rola para o topo da página
  };

    // Função para disparar o evento do Pixel
    const handlePixelContactEvent = () => {
      if (window.fbq) {
        window.fbq('track', 'Contact'); // Dispara o evento "Contact"
      }
    };

  return (
    <nav className="endbar">
      <div className="logo" onClick={handleScrollToTop}>
        <img src={logo} alt="Logo" />
      </div>
      <ul className="nav-links">
        <li><a href="https://www.linkedin.com/in/guedesdsgn/" target="_blank" rel="noreferrer" onClick={handlePixelContactEvent}>LinkedIn </a></li>
        <li><a href="https://www.instagram.com/guedes.idv/" target="_blank" rel="noreferrer" onClick={handlePixelContactEvent}>Instagram</a></li>
        <li><a href="https://wa.me/556196414079" target="_blank" rel="noreferrer" onClick={handlePixelContactEvent}>WhatsApp</a></li>
      </ul>
    </nav>
  );
}

export default Endbar;
